function Section({ tab, setTab, data, user, textContent }) {
  return (
    <section
      className={`tab-content ${tab === 3 ? "active" : ""}`}
      id="tab-contact"
    >
      <div className="section-content">
        <img src="images/49643.webp" alt="Contact Elite Special Solutions" />
        <div className="section-text">
          <h2>{textContent?.contact?.heading}</h2>
          <p>
            {textContent?.contact?.description}
          </p>

          <p>
            Email:{" "}
            <ul>
              <li>
                <a href={`mailto:${data.contact.email}`}>
                  {data?.contact?.email}
                </a>
              </li>
            </ul>
          </p>

          <p>
            Office:
            <ul>
              <li>
                <a href={`tel:${data.contact.phoneOffice}`}>
                  {data?.contact?.phoneOffice}
                </a>
              </li>
            </ul>
          </p>

          <p>
            WhatsApp:
            <ul>
              <li>
                <a href={data?.socialMedia?.whatsapp0} target="_blank" rel="noopener noreferrer" style={{cursor: "pointer"}}>
                  {data?.contact?.whatsApp0}
                </a>
              </li>
            </ul>
          </p>

          <p>
            <strong>{data?.contact?.companyName}</strong>
            <br />
            {data?.contact?.address}
          </p>

          { user == "company" ? (
            <p style={{ textAlign: "center" }}>
            {textContent?.contact?.company?.label} 
            <a style={{ textDecoration: "underline", cursor: "pointer", fontWeight: "bold" }} 
            href={data.externalLinks.serviceAgreementDetails} target="_blank" rel="noreferrer"
            > {textContent?.contact?.company?.cta}</a>
          </p>
          ) : null }

          <button
            className="cta-button"
            onClick={() => window.open("mailto:" + data.contact.email)}
          >
            {textContent?.contact?.ctaEmail} 
          </button>
          {/*<button className="cta-button" style={{margin: 5}} onClick={() => window.open('https://wa.me/+18882188542')}>Whatsapp</button>*/}
          <button
            className="cta-button"
            style={{ margin: 5 }}
            onClick={() => window.open(data.externalLinks.bookingURL, "_blank")}
          >
            {textContent?.contact?.ctaCall}
          </button>
        </div>
      </div>
    </section>
  );
}

export default Section;
